import * as ControlAll from "./Control";
import * as FormAll from "./Form";

export const Control = ControlAll.default;
export const Form = FormAll.default;
export const FieldHorizontal = FormAll.FieldHorizontal;
export const FieldVertical = FormAll.FieldVertical;
export const Field = FormAll.Field;
